import React, { type FC } from 'react'
import { Tooltip } from '@mui/material'

import type { BaseCommonProps } from '../common'
import { type AbsoluteRouteOnlyPath, ForwardRefPermissionedLink, PermissionedLink } from '../routing'
import type { ReadonlyPropsWithChildren } from '../utils'
import { useNavigationFormatter } from './Hooks'

const Wrapper: FC<ReadonlyPropsWithChildren<{ authorized: boolean }>> = ({ authorized, children }) => (authorized ? <>{children}</> : null)

export const NavigationPermissionedLink: FC<ReadonlyPropsWithChildren<{ path: AbsoluteRouteOnlyPath, withTooltip?: boolean } & BaseCommonProps>> = ({
    path,
    withTooltip,
    ...rest
}) => {
    const formatter = useNavigationFormatter()

    return withTooltip ? (
        <Tooltip title={formatter.formatTitle(path)} placement="right">
            <ForwardRefPermissionedLink path={path} color="inherit" wrapper={Wrapper} {...rest} />
        </Tooltip>
    ) : (
        <PermissionedLink path={path} color="inherit" title={formatter.formatDescription(path) ?? undefined} wrapper={Wrapper} {...rest} />
    )
}
